import React, { useEffect, useState } from 'react'
import type { FanResult } from '../../../../Api'
import { MultiBar } from './MultiBar'
import { BarOuter } from './styles'

type FanResultsProps = {
  seasonSegment: string
  fanBracketResults: FanResult[]
}

export const ResultsBreakdown: React.FC<React.PropsWithChildren<FanResultsProps>> = ({ fanBracketResults, seasonSegment }) => {
  const [totalPickCount, setTotalPickCount] = useState<number>(0)

  useEffect(() => {
    const total = getTotalPickCount()
    setTotalPickCount(total)
  }, [])

  const getTotalPickCount = () => {
    let count = 0
    //Get total from single game
    fanBracketResults.map((r) => {
      count = count + r.count
      return
    })
    return count
  }

  return (
    <BarOuter>
      <MultiBar seasonSegment={seasonSegment} fanBracketResults={fanBracketResults} totalCount={totalPickCount} />
    </BarOuter>
  )
}
